/**
 * Thin wrapper around Umami's window.umami API.
 * Silently no-ops if the script hasn't loaded yet (e.g. in dev without the CDN).
 */
export function useAnalytics() {
  const track = (eventName, data) => {
    if (typeof window !== 'undefined' && window.umami) {
      window.umami.track(eventName, data);
    }
  };

  return { track };
}
